<template>
  <div>
    <div class="bg-white p-3">
      <slot name="header" />
      <custom-separator class="my-2" text="Agregados" />
      <custom-result-not-found
        v-if="purchaseOrderNumbers.length == 0"
        text="No cuenta con información disponible."
      />

      <budget-sources
        v-for="(item, index) in purchaseOrderNumbers"
        :key="index"
        :is-read-only="isReadOnly"
        :item="item"
        @remove="onRemove"
      />

      <hr v-if="!isReadOnly" />
      <div v-if="!isReadOnly" class="div-container">
        <validation-observer ref="budgetSourcesObserver" slim>
          <div class="row">
            <div class="col-12 col-md">
              <label class="data-name">Tipo de Programa:</label>
              <custom-drop-down
                v-model="innerModel.programType"
                :class="{
                  'was-Invalidated-select':
                    validated && !innerModel.programType,
                }"
                :clearable="false"
                custom-error-msg="El campo es requerido"
                fieldkey="id"
                fieldname="name"
                :options="programTypes"
                placeholder="Seleccione"
                @input="onProgramTypeChange"
              />
              <error
                v-if="validated && !innerModel.programType"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md">
              <label class="data-name">Presupuesto:</label>
              <money
                v-model.lazy.number="innerModel.projectedFund"
                v-bind="moneyOptions"
                class="form-control"
                :class="{
                  'was-Invalidated': validated && innerModel.projectedFund <= 0,
                }"
              />
              <error
                v-if="validated && innerModel.projectedFund <= 0"
                message="Favor de añadir un valor mayor de cero"
                variant="no-border"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 col-md">
              <label class="data-name">Fund:</label>
              <custom-input
                v-model="innerModel.fund"
                :class="{ 'was-Invalidated': validated && !innerModel.fund }"
                custom-error-msg="El campo es requerido"
                maxlength="100"
                type="text"
              />
              <error
                v-if="validated && !innerModel.fund"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md">
              <label class="data-name">Agency:</label>
              <custom-input
                v-model="innerModel.dept"
                :class="{ 'was-Invalidated': validated && !innerModel.dept }"
                custom-error-msg="El campo es requerido"
                maxlength="100"
                type="text"
              />
              <error
                v-if="validated && !innerModel.dept"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md">
              <label class="data-name">Cost Center:</label>
              <custom-input
                v-model="innerModel.costCenter"
                :class="{
                  'was-Invalidated': validated && !innerModel.costCenter,
                }"
                custom-error-msg="El campo es requerido"
                maxlength="100"
                type="text"
              />
              <error
                v-if="validated && !innerModel.costCenter"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md">
              <label class="data-name">Program (PAS):</label>
              <custom-input
                v-model="innerModel.manualProgram"
                :class="{
                  'was-Invalidated': validated && !innerModel.manualProgram,
                }"
                custom-error-msg="El campo es requerido"
                maxlength="100"
                type="text"
              />
              <error
                v-if="validated && !innerModel.manualProgram"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md">
              <label class="data-name">Budget Year:</label>
              <custom-input
                v-model.number="innerModel.budRef"
                :class="{
                  'was-Invalidated': validated && !innerModel.budRef,
                }"
                custom-error-msg="El campo es requerido"
                type="number"
              />
              <error
                v-if="validated && !innerModel.budRef"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md">
              <label class="data-name">Approp:</label>
              <custom-input
                v-model="innerModel.class"
                :class="{ 'was-Invalidated': validated && !innerModel.class }"
                custom-error-msg="El campo es requerido"
                maxlength="100"
                type="text"
              />
              <error
                v-if="validated && !innerModel.class"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md">
              <label class="data-name">Account:</label>
              <custom-input
                v-model="innerModel.account"
                :class="{ 'was-Invalidated': validated && !innerModel.account }"
                custom-error-msg="El campo es requerido"
                maxlength="100"
                type="text"
              />
              <error
                v-if="validated && !innerModel.account"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md">
              <label class="data-name">ProjectID:</label>
              <custom-input
                v-model="innerModel.project"
                :class="{ 'was-Invalidated': validated && !innerModel.project }"
                custom-error-msg="El campo es requerido"
                maxlength="100"
                type="text"
              />
              <error
                v-if="validated && !innerModel.project"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
            <div class="col-12 col-md">
              <label class="data-name">InterFund:</label>
              <custom-input
                v-model="innerModel.interFund"
                :class="{
                  'was-Invalidated': validated && !innerModel.interFund,
                }"
                custom-error-msg="El campo es requerido"
                maxlength="100"
                type="text"
              />
              <error
                v-if="validated && !innerModel.interFund"
                message="El campo es requerido."
                variant="no-border"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 col-md-2">
              <label class="data-name">Future1:</label>
              <custom-input
                v-model="innerModel.future1"
                maxlength="100"
                type="text"
              />
            </div>
            <div class="col-12 col-md-2">
              <label class="data-name">Future2:</label>
              <custom-input
                v-model="innerModel.future2"
                maxlength="100"
                type="text"
              />
            </div>
            <div class="col-12 col-md-8">
              <label class="data-name">PRIFAS:</label>
              <custom-input
                v-model="innerModel.prifas"
                maxlength="500"
                type="text"
              />
            </div>
          </div>
          <div class="d-flex justify-content-end mt-3">
            <action-button
              i="fas fa-file-plus"
              text="Añadir"
              variant="success"
              @click="add"
            />
          </div>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import Error from 'custom-error';
import { moneyOptions } from '@/utils/objUtils';
import { Money } from 'v-money';
import ActionButton from 'ActionButton';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import alertMixin from '@/mixins/alert.mixin.js';
import { getPrograms } from '@/modules/purchaseService/api.js';
import BudgetSources from '../BudgetSources.vue';

export default {
  name: 'BudgetSourceFunds',
  components: {
    Error,
    CustomDropDown,
    CustomInput,
    CustomSeparator,
    Money,
    CustomResultNotFound,
    ActionButton,
    BudgetSources,
  },
  mixins: [alertMixin],
  props: {
    model: {
      type: Object,
      required: true,
    },
    programTypes: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    isActual: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      moneyOptions,
      validated: false,
      innerModel: {
        programType: null,
        projectedFund: 0,
        fund: null,
        dept: null,
        costCenter: null,
        manualProgram: null,
        budRef: null,
        class: null,
        account: null,
        project: null,
        interFund: null,
        future1: null,
        future2: null,
        prifas: null,
        isActual: this.isActual,
      },
      programs: [],
    };
  },
  computed: {
    purchaseOrderNumbers() {
      return (
        this.model.purchaseOrderNumber.filter(
          (x) => x.isActual == this.isActual
        ) || []
      );
    },
  },
  methods: {
    async onProgramTypeChange() {
      if (!this.innerModel.programType) {
        return;
      }

      const { data } = await getPrograms(this.innerModel.programType.id);

      this.programs = data;
    },
    validate() {
      this.validated = true;

      // Campos requeridos (Future1/Future2 son opcionales)
      const required = [
        this.innerModel.programType,
        this.innerModel.fund,
        this.innerModel.dept,
        this.innerModel.costCenter,
        this.innerModel.manualProgram,
        this.innerModel.budRef,
        this.innerModel.class,
        this.innerModel.account,
        this.innerModel.project,
        this.innerModel.interFund,
      ];

      const allFilled = required.every(Boolean);
      const validFund = Number(this.innerModel.projectedFund) > 0;

      return allFilled && validFund;
    },
    async add() {
      const isValid = this.validate();

      if (!isValid) {
        this.ShowToast('', 'Debe completar los campos requeridos', 'error');
        return;
      }

      this.model.purchaseOrderNumber.push({
        ...this.innerModel,
      });

      this.validated = false;

      Object.keys(this.innerModel).forEach((key) => {
        if (key === 'projectedFund') {
          this.innerModel[key] = 0;
        } else if (key === 'isActual') {
          this.innerModel[key] = this.isActual;
        } else {
          this.innerModel[key] = null;
        }
      });
    },
    setValidation(val) {
      this.validated = val;
    },
    onRemove(item) {
      const i = this.model.purchaseOrderNumber.findIndex((x) => x === item);

      this.model.purchaseOrderNumber.splice(i, 1);

      this.$emit('items-changes', this.model.purchaseOrderNumber);
    },
  },
};
</script>
<style scoped>
.custom-radio ::v-deep .col-12 {
  padding: 0 !important;
}
.custom-font {
  color: #727272;
  font-size: 14px;
}
::v-deep .custom-datetime-picker-container {
  width: 100% !important;
  input[type='text'] {
    width: 100%;
  }
}

.div-container {
  padding: 24px;
  background: white;
  border-radius: 4px;
  outline: 1px solid #e2e2e2;
  outline-offset: -1px;
}

.custom-chips-group ::v-deep .mt-3 {
  margin-top: 0 !important;
}
.custom-chips-group ::v-deep .chips-container {
  margin-top: 0 !important;
}
.custom-chips-group ::v-deep .chips-container .bold {
  font-weight: 400 !important;
}

.custom-chips-group ::v-deep .chips-container .label > .inline {
  font-size: 1rem;
  font-weight: 700 !important;
  color: #1b1b1b !important;
}

input.was-Invalidated,
.was-Invalidated ::v-deep input,
div.was-Invalidated-select ::v-deep .v-select > div {
  background-color: #f7d7da;
  border: 1px solid #ff0018 !important;
}
::v-deep div.was-Invalidated {
  border: none !important;
}
</style>
